import * as React from "react";
import { KitsList } from "./KitsList";
import { KitsDetails } from "./KitsDetails";
import { Route, Routes } from "react-router";
import { RouteContent } from "@common/RouteContent";

export interface IKitsProps {
    baseUrl: string;
}
export const Kits: React.FC<IKitsProps> = (props) => {

    return (
        <Routes>
            <Route path="" element={<KitsList baseUrl={props.baseUrl} />} />
            <Route path={`:kitId/detail`} element={<RouteContent render={(params) => <KitsDetails kitId={parseInt(params.params.kitId)} />} />} />
        </Routes>
    );

}

